<main class="container">
  <!-- ورود به حساب کاربری -->
  <div class="modal show bg-secondary" style="display: block">
    <div
      class="modal-dialog modal-dialog-centered flex-column justify-content-center"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title mb-0" id="exampleModalLabel">
            {{ bLoginMode ? "ورود به حساب کاربری" : "ثبت نام" }}
          </h2>

          <button type="button" class="btn" (click)="dismissModal()">
            <mat-icon class="mat-18">close</mat-icon>
          </button>
        </div>

        <form [formGroup]="signUpModel" class="modal-body">
          <h2 class="">{{ !bSendOtp ? "" : "کد تأیید را وارد کنید" }}</h2>

          <!-- ثبت‌ نام یا OTP -->
          <ng-container *ngIf="!bLoginMode">
            <span class="">
              {{ !bSendOtp ? "" : (otpMessage | faNum) }}

              <span
                *ngIf="bSendOtp"
                id="changeNumber-btn"
                class="change-number"
                (click)="changeNumber()"
              >
                تغییر شماره
              </span>
            </span>
          </ng-container>

          <!-- پیام حالت لاگین -->
          <span *ngIf="bLoginMode">
            شماره موبایل متعلق به خودتان را وارد کنید.
          </span>

          <!-- فیلد موبایل -->
          <ng-container *ngIf="isLoginMode">
            <div class="form-group has-icon direction-ltr">
              <span class="form-control-icon">
                <mat-icon class="mat-18">phone_iphone</mat-icon>
              </span>

              <input
                class="mt-4 w-100 form-control"
                formControlName="strMobile"
                [placeholder]="valid_PlaceHolder | faNum"
                appNumericOnly
                inputmode="numeric"
                [maxlength]="valid_MaxLength"
              />
            </div>
          </ng-container>

          <!-- قوانین در حالت لاگین -->

          <div *ngIf="isLoginMode" class="d-flex mt-2 rules-wrapper">
            <input
              type="checkbox"
              formControlName="rules"
              (change)="checkRules($event)"
              required
            />

            <label class="px-1">
              <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را
              مطالعه کردم و موافقم
            </label>
          </div>

          <!-- فرم ثبت‌ نام -->

          <ng-container *ngIf="isSignUpMode">
            <!-- نام/نام خانوادگی -->

            <div class="w-100 h-100">
              <div class="row gx-2 gy-0">
                <!-- نام -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">person</mat-icon>
                    </span>

                    <input
                      class="w-100 mb-3 mb-md-0 form-control"
                      formControlName="strName"
                      placeholder="* نام"
                    />
                  </div>
                </div>

                <!-- نام خانوادگی -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">person</mat-icon>
                    </span>

                    <input
                      class="w-100 form-control"
                      formControlName="strFamily"
                      placeholder="* نام خانوادگی"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- کدملی مالک شناور -->

            <div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">badge</mat-icon>
              </span>

              <input
                class="my-3 w-100 form-control"
                formControlName="strID"
                [ngClass]="
                  signUpModel.get('strID').value ? 'direction-ltr' : ''
                "
                placeholder="* کد ملی مالک خودرو"
                inputmode="numeric"
                maxlength="10"
                appNumericOnly
              />
            </div>

            <!-- تلفن ثابت -->
            <!-- Temporary disabled -->
            <div *ngIf="false" class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">fax</mat-icon>
              </span>

              <input
                class="my-3 w-100 form-control"
                formControlName="strTel"
                [ngClass]="
                  signUpModel.get('strTel').value ? 'direction-ltr' : ''
                "
                placeholder="* تلفن ثابت"
                inputmode="numeric"
                minlength="8"
                appNumericOnly
              />
            </div>

            <!-- استان/شهر -->

            <div class="w-100 h-100">
              <div class="row gx-2 gy-0">
                <!-- استان -->
                <!-- Temporary disabled -->
                <div *ngIf="false" class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">apartment</mat-icon>
                    </span>

                    <select
                      class="w-100 mb-3"
                      formControlName="strStateCode"
                      (change)="getCity($event.target.value)"
                    >
                      <option value="">* استان</option>

                      <option *ngFor="let s of lst_States" [value]="s.strState">
                        {{ s.strStateName }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- شهر/بندر -->
                <!-- Temporary disabled -->
                <div *ngIf="false" class="col-12 col-md-6">
                  <div class="form-group has-icon mb-3">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">apartment</mat-icon>
                    </span>

                    <select class="w-100" formControlName="strCity">
                      <option value="">* شهر</option>

                      <option
                        *ngFor="let c of list_City"
                        [value]="c.strCity.trim()"
                      >
                        {{ c.strCityName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- آدرس محل نصب -->
            <!-- Temporary disabled -->
            <div
              *ngIf="false"
              class="form-group position-relative has-icon mb-3"
            >
              <span class="form-control-icon">
                <mat-icon class="mat-18">add_location_alt</mat-icon>
              </span>

              <input
                class="w-100 form-control"
                formControlName="strAddress"
                [placeholder]="addressPlaceHolder"
              />

              <button class="btn btn-warning rounded" (click)="show_Map()">
                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
              </button>

              <custom-map
                *ngIf="openMap"
                [strValue]="mdl_Map.get('strAddress')?.value"
                [longLat]="[
                  mdl_Map.get('fLon')?.value,
                  mdl_Map.get('fLat')?.value,
                ]"
                [isOpenModal]="true"
                (mdl_Submit)="submitMap($event)"
              >
              </custom-map>
            </div>

            <!-- نوع تانکر -->
            <!-- Temporary disabled -->
            <div *ngIf="false" class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">fire_truck</mat-icon>
              </span>

              <select class="w-100 mb-3" formControlName="tiGPSType">
                <option [value]="null" disabled selected>* نوع تانکر</option>
                <option
                  *ngFor="let carType of carTypes$ | async"
                  [value]="carType.tiGPSType"
                >
                  {{ carType.strComment }}
                </option>
              </select>
            </div>

            <!-- vehicleNumber field -->

            <div class="vehicle-no-field-wrapper">
              <app-qasr-plate formControlName="strVehicleNo"></app-qasr-plate>
            </div>

            <!-- تصویر مجوز صادره از طرف شرکت آب و فاضلاب  -->
            <!-- Temporary disabled -->
            <div *ngIf="false" class="form-group position-relative mb-3">
              <p class="my-2">
                * تصویر مجوز صادره از طرف شرکت آب و فاضلاب را آپلود کنید.
              </p>

              <file-uploader
                [maxFileSize]="3"
                (submit)="onFileSubmit($event)"
              ></file-uploader>
            </div>

            <!-- توضیحات -->

            <div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">description</mat-icon>
              </span>

              <textarea
                style="height: 100px"
                type="text"
                class="w-100 mb-3 form-control"
                placeholder=" توضیحات"
                formControlName="strComment"
              ></textarea>
            </div>

            <!-- قوانین ثبت‌ نام -->

            <div class="d-flex rules-wrapper">
              <input
                type="checkbox"
                formControlName="rules"
                (change)="checkRules($event)"
                required
              />

              <label class="px-1">
                <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را
                مطالعه کردم و موافقم
              </label>
            </div>
          </ng-container>

          <!-- فرم OTP -->

          <ng-container *ngIf="isOtpMode">
            <div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">sms</mat-icon>
              </span>

              <input
                class="w-100 my-3 form-control"
                formControlName="strActivateCode"
                [ngClass]="
                  signUpModel.get('strActivateCode').value
                    ? 'direction-ltr'
                    : ''
                "
                placeholder="کد تایید"
                appNumericOnly
                maxlength="4"
                inputmode="numeric"
              />
            </div>
          </ng-container>
        </form>

        <div class="modal-footer d-flex flex-row-reverse justify-content-end">
          <button
            type="button"
            class="btn btn-primary px-4"
            (click)="onSubmit()"
            [disabled]="isSubmitDisabled"
          >
            {{ !bSendOtp && !bLoginMode ? "ثبت نام" : "تایید" }}
          </button>

          <button
            *ngIf="bSendOtp && !bLoginMode"
            type="button"
            class="btn btn-outline-dark px-4"
            (click)="sendAgain_Otp()"
            [disabled]="otpTimer !== 0"
          >
            ارسال مجدد کد

            <span *ngIf="otpTimer !== 0" class="me-1">
              {{ otpTimer | faNum }}
            </span>
          </button>
        </div>
      </div>

      <ng-container *ngIf="isLoginMode">
        <div class="alert alert-secondary my-0 mt-2">
          <p class="my-0 p-0">
            <small class="fw-bold">
              {{
                " در صورت بروز مشکل، با شماره موردنظر تماس حاصل فرمایید: 88743090-021"
                  | faNum
              }}
            </small>
          </p>
        </div>
      </ng-container>
    </div>
  </div>
</main>
